class Request {
    static post(url, data = null, headers = null) {
        return Request.createRequest('POST', url, data, headers);
    }

    static put(url, data = null, headers = null) {
        return Request.createRequest('PUT', url, data, headers);
    }

    static delete(url, data = null, headers = null) {
        return Request.createRequest('DELETE', url, data, headers);
    }

    static get(url, headers = null) {
        return Request.createRequest('GET', url, headers);
    }

    static createRequest(method = 'GET', url = '', data = null, headers = null) {
        return new Promise(function(resolve, reject) {
            let req = new XMLHttpRequest();
            req.open(method, url, true);

            req.setRequestHeader('Content-type', 'application/json; charset=utf-8');

            if(headers) {
                headers.forEach(header => {
                    req.setRequestHeader(header.type, header.value);
                });
            }

            req.onload = function() {
                if(req.status === 200) {
                    resolve(req.response);
                }
                else {
                    reject(Error(req.statusText));
                }
            }

            req.onerror = function() {
                reject(Error('Network Error'));
            }

            if(data) {
                req.send(JSON.stringify(data));
            }
            else {
                req.send();
            }
        });
    }
}
export { Request as default}